module.exports = __webpack_public_path__ + "img/service05.9c20ede1.jpg";